export const techStack = [

  { name: "C Language", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg" },

  { name: "C++", link: "https://raw.githubusercontent.com/jmnote/z-icons/bd73f8f803467f185ffd94f4fc7c24ce931eb926/svg/cpp.svg" },
  { name: "Express", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg" },

  { name: "NodeJS", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg" },
  { name: "Postman", link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },

  { name: "Java", link: "https://raw.githubusercontent.com/jmnote/z-icons/bd73f8f803467f185ffd94f4fc7c24ce931eb926/svg/java.svg" },
  { name: "GitHub", link: "https://raw.githubusercontent.com/jmnote/z-icons/bd73f8f803467f185ffd94f4fc7c24ce931eb926/svg/github.svg" },
  { name: "Material-UI", link: "https://raw.githubusercontent.com/devicons/devicon/1119b9f84c0290e0f0b38982099a2bd027a48bf1/icons/materialui/materialui-original.svg" },
  { name: "HTML", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
  { name: "CSS", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg" },
  { name: "Bootstrap", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg" },
  { name: "Mongoose", link: "https://4008838.fs1.hubspotusercontent-na1.net/hubfs/4008838/mogoose-logo.png" },
  { name: "Netlify", link: "https://cdn.icon-icons.com/icons2/2699/PNG/512/netlify_logo_icon_169923.png" },

  { name: "Javascript", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
  { name: "Tailwind CSS", link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" },
  { name: "React", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" },
  { name: "MySQl", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-plain.svg" },
  { name: "Mongo DB", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg" },
  { name: "Heroku", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg" },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  { name: "Git", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg" },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  { name: "Firebase", link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },

  // { name: "Bash", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg" },
  // { name: "Vim", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vim/vim-original.svg" },

  // { name: "VS Code", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
  // {name: "", link: "https://repository-images.githubusercontent.com/59065830/b62be480-45d2-11ea-9989-803db0f9c44d"}
]


export const contactLinks = [
  //  { name: 'Leet Code', url: 'https://img.icons8.com/doodle/40/000000/leetcode--v2.png', link: 'https://stackoverflow.com/users/11788531/aakash-sharma' },
  { name: 'Instagram', url: 'https://img.icons8.com/doodle/40/000000/instagram-new--v2.png', link: 'https://www.instagram.com/aadil0825/' },
  { name: 'Github', url: 'https://img.icons8.com/doodle/40/000000/github--v1.png', link: 'https://github.com/M-Aadil' },
  { name: 'LinkedIn', url: 'https://img.icons8.com/doodle/40/000000/linkedin--v2.png', link: 'https://www.linkedin.com/in/md-aadil-ansari-b26786221/' }
]



export const serviceData = [
  // {
  //   name: 'Quora For College',
  //   desc: `CollegeQuora is a website where every query related to jmi will be answered directly from the senior students or faculties there. For the sake of convenience one will find categories like placement, admission, fees etc. `,

  //   img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  //   url: "https://mycryptotrapper.netlify.app/",
  //   tech: 'React JS, Css, Express JS, MySQL'
  // },
  {
    name: 'CryptoTrapper',
    desc: `An app for crypto currency lover to check rank, current price, marketCap & historical chart for trending crypto-currency. Used Reactjs with MIUI to create user-friendly UI, CoinGecko API for price, rank etc of a crypto currency.`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
    url: "https://mycryptotrapper.netlify.app/",
    tech: 'React JS, Material UI, Chart JS, Express JS, Firebase'
  },

   {
     name: 'Anveshan',
     desc: `Anveshan app helps in extracting Crypto Currency details from public addresses for investigation. CC-Scan decodes QR code to provide details such as transaction count, public address validity and last balance change.`,
     img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
     url: "https://github.com/M-Aadil/Anveshan",
     tech: 'React JS, Blockchair API, Zxing library, Bootstrap'
   },

   {
     name: 'Dictionaty',
     desc: `A crowd-sourced dictionary which supports multiple languages, provides concise definitions along with examples on the usage of words. Used Reactjs for frontend and back-end contribution.`,
     img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
     url: "https://community-dictionary-dev.web.app/",
     tech: 'React JS, CSS, GitHub'
   },


]